import styled from 'styled-components/macro'

const AdditionalInfo = styled('span')`
  color: #888;
`

export default AdditionalInfo
